import React from 'react';


/**
 * In-house Statbox icons. One optical size, square corners, and a small
 * nested-square mark so the set reads as one family — not a stock icon pack.
 */
const S = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const ICONS = {
  overview: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" {...S} />
      <path d="M7.5 15.5v-3.2M12 15.5V8.5M16.5 15.5v-1.8" {...S} />
      <rect x="10.6" y="7.1" width="2.8" height="2.8" rx="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  calendar: (
    <>
      <rect x="3.5" y="5" width="17" height="15" rx="2.5" {...S} />
      <path d="M3.5 9.5h17" {...S} />
      <path d="M8 3.5v3M16 3.5v3" {...S} />
      <rect x="7" y="12" width="2.2" height="2.2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="11" y="12" width="2.2" height="2.2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="15" y="12" width="2.2" height="2.2" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  create: (
    <>
      <rect x="3.5" y="5" width="17" height="14" rx="2" {...S} />
      <path d="M12 5v14M3.5 12h17" {...S} />
      <rect x="10.2" y="10.2" width="3.6" height="3.6" rx="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  video: (
    <>
      <rect x="3.5" y="6" width="13" height="12" rx="2" {...S} />
      <path d="M16.5 10.2 20.5 8.2v7.6l-4-2" {...S} />
      <rect x="8.2" y="10.4" width="3.2" height="3.2" rx="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  roster: (
    <>
      <rect x="4" y="3.5" width="16" height="17" rx="2.5" {...S} />
      <path d="M4 8h16" {...S} />
      <circle cx="8" cy="12" r="1.1" fill="currentColor" stroke="none" />
      <path d="M11 12h5" {...S} />
      <circle cx="8" cy="16" r="1.1" fill="currentColor" stroke="none" />
      <path d="M11 16h5" {...S} />
    </>
  ),
  teams: (
    <>
      <rect x="3.5" y="8" width="8.5" height="11" rx="2" {...S} />
      <rect x="12" y="5" width="8.5" height="11" rx="2" {...S} />
      <rect x="10.2" y="13.2" width="3.6" height="3.6" rx="0.5" fill="currentColor" stroke="none" />
    </>
  ),
  leagues: (
    <>
      <path d="M5 6h4.5v4H5zM14.5 6H19v4h-4.5zM9.5 14H14v4H9.5z" {...S} />
      <path d="M7.25 10v2h9.5V10M12 12v2" {...S} />
    </>
  ),
  drills: (
    <>
      <path d="M12 4.5 18 17.5H6L12 4.5z" {...S} />
      <path d="M9.2 12.5h5.6" {...S} />
      <rect x="10.7" y="8.2" width="2.6" height="2.6" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  footprints: (
    <>
      <path d="M8.2 14.2c.9 0 1.6.8 1.6 1.9S9.1 18 8.2 18s-1.6-.8-1.6-1.9.7-1.9 1.6-1.9z" {...S} />
      <path d="M7.4 8.2c.2 1.2.8 2.2 1.6 2.8" {...S} />
      <circle cx="6.2" cy="7.2" r="0.7" fill="currentColor" stroke="none" />
      <circle cx="8.4" cy="6.6" r="0.7" fill="currentColor" stroke="none" />
      <path d="M16.4 15.4c.9 0 1.6.8 1.6 1.9s-.7 1.9-1.6 1.9-1.6-.8-1.6-1.9.7-1.9 1.6-1.9z" {...S} />
      <path d="M15.2 9.4c.2 1.2.8 2.2 1.6 2.8" {...S} />
      <circle cx="14.2" cy="8.4" r="0.7" fill="currentColor" stroke="none" />
      <circle cx="16.4" cy="7.8" r="0.7" fill="currentColor" stroke="none" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" {...S} />
      <path d="M12 3.5v2.2M12 18.3v2.2M3.5 12h2.2M18.3 12h2.2M5.8 5.8l1.6 1.6M16.6 16.6l1.6 1.6M18.2 5.8l-1.6 1.6M7.4 16.6l-1.6 1.6" {...S} />
    </>
  ),
  matches: (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2" {...S} />
      <path d="M12 5.5v13M3.5 12h17" {...S} />
      <circle cx="12" cy="12" r="2.2" {...S} />
    </>
  ),
  discovery: (
    <>
      <path d="M5 9V5.5h3.5M15.5 5.5H19V9M19 15v3.5h-3.5M8.5 18.5H5V15" {...S} />
      <rect x="10.2" y="10.2" width="3.6" height="3.6" rx="0.5" fill="currentColor" stroke="none" />
    </>
  ),
  competitions: (
    <>
      <path d="M8 4.5h8v3.2a4 4 0 0 1-8 0V4.5z" {...S} />
      <path d="M8 6.2H5.8A2.2 2.2 0 0 0 8 9.2M16 6.2h2.2A2.2 2.2 0 0 1 16 9.2" {...S} />
      <path d="M12 11.7v2.3M9 18.5h6M10 16.5h4v2" {...S} />
    </>
  ),
  challenges: (
    <>
      <path d="M7 4.5h10v2.4a5 5 0 0 1-10 0V4.5z" {...S} />
      <path d="M12 11.9v2.1" {...S} />
      <path d="M8.2 18.5h7.6l-1.3-3.1H9.5L8.2 18.5z" {...S} />
      <rect x="10.7" y="5.4" width="2.6" height="2.6" rx="0.35" fill="currentColor" stroke="none" />
    </>
  ),
  leaderboard: (
    <>
      <path d="M4 18.5h16" {...S} />
      <rect x="5" y="11" width="3.6" height="7.5" rx="0.6" {...S} />
      <rect x="10.2" y="6.5" width="3.6" height="12" rx="0.6" {...S} />
      <rect x="15.4" y="13" width="3.6" height="5.5" rx="0.6" {...S} />
      <rect x="11.1" y="8" width="1.8" height="1.8" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  analytics: (
    <>
      <path d="M4 19.2h16" {...S} />
      <rect x="5.4" y="12.2" width="3.2" height="7" rx="0.5" {...S} />
      <rect x="10.4" y="7.2" width="3.2" height="12" rx="0.5" {...S} />
      <rect x="15.4" y="9.6" width="3.2" height="9.6" rx="0.5" {...S} />
      <rect x="11.2" y="8.8" width="1.6" height="1.6" rx="0.25" fill="currentColor" stroke="none" />
    </>
  ),
  library: (
    <>
      <rect x="6" y="5" width="14" height="14" rx="2" {...S} />
      <path d="M6 8.5h14" {...S} />
      <rect x="3.5" y="8" width="4" height="11" rx="1.2" {...S} />
    </>
  ),
  management: (
    <>
      <rect x="3.5" y="4" width="7" height="7" rx="1.4" {...S} />
      <rect x="13.5" y="4" width="7" height="7" rx="1.4" fill="currentColor" stroke="none" />
      <rect x="3.5" y="13" width="7" height="7" rx="1.4" {...S} />
      <rect x="13.5" y="13" width="7" height="7" rx="1.4" {...S} />
    </>
  ),
  ball: (
    <>
      <circle cx="12" cy="12" r="8" {...S} />
      <path d="M12 4c2 2.2 2 13.8 0 16M12 4c-2 2.2-2 13.8 0 16M4.8 9.2h14.4M4.8 14.8h14.4" {...S} />
    </>
  ),
  hoop: (
    <>
      <circle cx="12" cy="9" r="4.5" {...S} />
      <path d="M8.2 12.2c.6 2.4 1.8 4.2 3.8 5.3 2-1.1 3.2-2.9 3.8-5.3" {...S} />
      <path d="M12 4.5V3M7.5 4.2 12 3l4.5 1.2" {...S} />
    </>
  ),
  bell: (
    <>
      <path d="M6 16.5h12l-1.2-2.1V10a4.8 4.8 0 0 0-9.6 0v4.4L6 16.5z" {...S} />
      <path d="M10 16.5a2 2 0 0 0 4 0" {...S} />
      <rect x="10.8" y="4" width="2.4" height="2.4" rx="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  logout: (
    <>
      <path d="M9 5.5H6.5A1.5 1.5 0 0 0 5 7v10a1.5 1.5 0 0 0 1.5 1.5H9" {...S} />
      <path d="M10 12h9M16 8.5 19.5 12 16 15.5" {...S} />
    </>
  ),
  users: (
    <>
      <rect x="3.2" y="4.8" width="7.4" height="7.4" rx="1.4" {...S} />
      <path d="M3.2 18.8c.5-2.5 2.1-3.7 3.7-3.7s3.2 1.2 3.7 3.7" {...S} />
      <rect x="13.2" y="6" width="6.6" height="6.6" rx="1.2" fill="currentColor" stroke="none" />
      <path d="M13.2 18.8c.4-2.1 1.7-3.1 3.3-3.1s2.9 1 3.3 3.1" {...S} />
    </>
  ),
  search: (
    <>
      <rect x="3.5" y="3.5" width="12.2" height="12.2" rx="2" {...S} />
      <path d="M14.2 14.2 20 20" {...S} />
      <rect x="7.1" y="7.1" width="5" height="5" rx="0.5" fill="currentColor" stroke="none" />
    </>
  ),
  menu: (
    <>
      <path d="M4 7h16M4 12h16M4 17h10" {...S} />
    </>
  ),
  close: (
    <>
      <path d="M6 6l12 12M18 6 6 18" {...S} />
    </>
  ),
  chevronLeft: (
    <path d="M14.5 6 8.5 12l6 6" {...S} />
  ),
  chevronRight: (
    <path d="M9.5 6 15.5 12l-6 6" {...S} />
  ),
  chevronDown: (
    <path d="M6 9.5 12 15.5 18 9.5" {...S} />
  ),
  plus: (
    <>
      <rect x="10.15" y="3.8" width="3.7" height="16.4" rx="0.7" fill="currentColor" stroke="none" />
      <rect x="3.8" y="10.15" width="16.4" height="3.7" rx="0.7" fill="currentColor" stroke="none" />
    </>
  ),
  upload: (
    <>
      <path d="M12 15.5V6M8.5 9.2 12 5.5l3.5 3.7" {...S} />
      <path d="M5 16.5v2A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5v-2" {...S} />
    </>
  ),
  eye: (
    <>
      <path d="M3.5 12S6.8 7 12 7s8.5 5 8.5 5-3.3 5-8.5 5S3.5 12 3.5 12z" {...S} />
      <circle cx="12" cy="12" r="2.2" {...S} />
    </>
  ),
  arrowRight: (
    <path d="M5 12h14M14 7l5 5-5 5" {...S} />
  ),
  branch: (
    <>
      <circle cx="7" cy="6" r="2" {...S} />
      <circle cx="7" cy="18" r="2" {...S} />
      <circle cx="17" cy="10" r="2" {...S} />
      <path d="M7 8v8M9 6h4a4 4 0 0 1 4 4" {...S} />
    </>
  ),
  coins: (
    <>
      <ellipse cx="12" cy="8" rx="6.5" ry="2.6" {...S} />
      <path d="M5.5 8v4c0 1.4 2.9 2.6 6.5 2.6s6.5-1.2 6.5-2.6V8" {...S} />
      <path d="M5.5 12v4c0 1.4 2.9 2.6 6.5 2.6s6.5-1.2 6.5-2.6v-4" {...S} />
    </>
  ),
  school: (
    <>
      <path d="M4 10.5 12 6l8 4.5-8 4.5-8-4.5z" {...S} />
      <path d="M7.5 12.2V16c1.4 1.2 2.9 1.8 4.5 1.8s3.1-.6 4.5-1.8v-3.8" {...S} />
      <rect x="11.2" y="9.2" width="1.6" height="1.6" rx="0.2" fill="currentColor" stroke="none" />
    </>
  ),
  lock: (
    <>
      <rect x="6" y="10.5" width="12" height="9" rx="2" {...S} />
      <path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" {...S} />
    </>
  ),
  card: (
    <>
      <rect x="3.5" y="6" width="17" height="12" rx="2" {...S} />
      <path d="M3.5 10.5h17" {...S} />
      <rect x="6.5" y="13.5" width="4" height="1.6" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10z" {...S} />
      <circle cx="12" cy="11" r="1.8" {...S} />
    </>
  ),
  alert: (
    <>
      <path d="M12 4.5 20 19H4L12 4.5z" {...S} />
      <path d="M12 10v4" {...S} />
      <rect x="11.2" y="15.4" width="1.6" height="1.6" rx="0.2" fill="currentColor" stroke="none" />
    </>
  ),
  mail: (
    <>
      <rect x="3.5" y="6" width="17" height="12" rx="2" {...S} />
      <path d="M4 7.5 12 13l8-5.5" {...S} />
    </>
  ),
  sliders: (
    <>
      <path d="M4 8h16M4 16h16" {...S} />
      <rect x="8" y="6" width="3.2" height="4" rx="0.6" fill="currentColor" stroke="none" />
      <rect x="13" y="14" width="3.2" height="4" rx="0.6" fill="currentColor" stroke="none" />
    </>
  ),
  activity: (
    <>
      <path d="M3.5 12h4l2-5 3.5 10 2-5h5.5" {...S} />
      <rect x="10.2" y="10.2" width="2.2" height="2.2" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  arrowLeft: <path d="M19 12H5M10 7 5 12l5 5" {...S} />,
  arrowUpRight: <path d="M7 17 17 7M9 7h8v8" {...S} />,
  arrowDownRight: <path d="M7 7l10 10M17 9v8H9" {...S} />,
  swap: (
    <>
      <path d="M7 7h11M15 4.5 18 7l-3 2.5" {...S} />
      <path d="M17 17H6M9 14.5 6 17l3 2.5" {...S} />
    </>
  ),
  sort: <path d="M8 5v14M5.5 8 8 5.5 10.5 8M16 19V5M13.5 16 16 18.5 18.5 16" {...S} />,
  book: (
    <>
      <path d="M5 5.5h6.2A2.8 2.8 0 0 1 14 8.3V19a2.2 2.2 0 0 0-2.2-2.2H5V5.5z" {...S} />
      <path d="M19 5.5h-6.2A2.8 2.8 0 0 0 10 8.3V19a2.2 2.2 0 0 1 2.2-2.2H19V5.5z" {...S} />
    </>
  ),
  bookmark: (
    <>
      <path d="M7 4.5h10v15l-5-3-5 3v-15z" {...S} />
      <rect x="10.8" y="7.2" width="2.4" height="2.4" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  camera: (
    <>
      <rect x="3.5" y="7" width="17" height="12" rx="2" {...S} />
      <path d="M9 7 10.2 5h3.6L15 7" {...S} />
      <circle cx="12" cy="13" r="3" {...S} />
    </>
  ),
  check: <path d="M5 12.5 9.2 17 19 7" {...S} />,
  checkCircle: (
    <>
      <circle cx="12" cy="12" r="8" {...S} />
      <path d="M8.2 12.2 11 15l4.8-5.5" {...S} />
    </>
  ),
  help: (
    <>
      <circle cx="12" cy="12" r="8" {...S} />
      <path d="M9.5 9.5a2.5 2.5 0 1 1 3.2 2.4c-.7.3-1.2.9-1.2 1.6" {...S} />
      <rect x="11.2" y="15.2" width="1.6" height="1.6" rx="0.2" fill="currentColor" stroke="none" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8" {...S} />
      <path d="M12 8v4.2l2.8 1.8" {...S} />
    </>
  ),
  copy: (
    <>
      <rect x="8" y="8" width="11" height="11" rx="2" {...S} />
      <path d="M6 16H5.5A1.5 1.5 0 0 1 4 14.5v-9A1.5 1.5 0 0 1 5.5 4h9A1.5 1.5 0 0 1 16 5.5V6" {...S} />
    </>
  ),
  target: (
    <>
      <path d="M4.5 19V7.2h15V19" {...S} />
      <path d="M4.5 11.6h15M8.4 7.2v4.4M15.6 7.2v4.4" {...S} />
      <rect x="10.2" y="14.1" width="3.6" height="3.6" rx="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  crown: (
    <>
      <path d="M4.5 18.5h15" {...S} />
      <rect x="5.2" y="11.2" width="3.4" height="7.3" rx="0.5" {...S} />
      <rect x="10.3" y="7.2" width="3.4" height="11.3" rx="0.5" {...S} />
      <rect x="15.4" y="4.2" width="3.4" height="14.3" rx="0.5" fill="currentColor" stroke="none" />
    </>
  ),
  download: (
    <>
      <path d="M12 5v9M8.5 11.2 12 14.8l3.5-3.6" {...S} />
      <path d="M5 16.5v2A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5v-2" {...S} />
    </>
  ),
  edit: (
    <>
      <path d="M4.5 19.5h4l10-10-4-4-10 10v4z" {...S} />
      <path d="M13 7.5 16.5 11" {...S} />
    </>
  ),
  external: <path d="M10 6H6.5A1.5 1.5 0 0 0 5 7.5v10A1.5 1.5 0 0 0 6.5 19h10a1.5 1.5 0 0 0 1.5-1.5V14M13 5h6v6M19 5l-8 8" {...S} />,
  file: (
    <>
      <path d="M7 4.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-9.5A1.5 1.5 0 0 1 5.5 19V6A1.5 1.5 0 0 1 7 4.5z" {...S} />
      <path d="M14 4.5V9h4.5" {...S} />
    </>
  ),
  filter: (
    <>
      <path d="M4 6.5h16M6.5 12h11M9.2 17.5h5.6" {...S} />
      <rect x="15.4" y="5.1" width="2.8" height="2.8" rx="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  folderPlus: (
    <>
      <path d="M3.5 8.5V18a1.5 1.5 0 0 0 1.5 1.5h14A1.5 1.5 0 0 0 20.5 18V9.5A1.5 1.5 0 0 0 19 8H11L9.2 6H5A1.5 1.5 0 0 0 3.5 7.5v1z" {...S} />
      <path d="M12 12v4M10 14h4" {...S} />
    </>
  ),
  grid: (
    <>
      <rect x="4" y="4" width="6.5" height="6.5" rx="1.2" {...S} />
      <rect x="13.5" y="4" width="6.5" height="6.5" rx="1.2" {...S} />
      <rect x="4" y="13.5" width="6.5" height="6.5" rx="1.2" {...S} />
      <rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.2" fill="currentColor" stroke="none" />
    </>
  ),
  grip: (
    <>
      <rect x="9" y="5" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="13" y="5" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="9" y="11" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="13" y="11" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="9" y="17" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="13" y="17" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  hand: <path d="M8 11V6.5a1.3 1.3 0 0 1 2.6 0V11M10.6 10.2V5.8a1.3 1.3 0 0 1 2.6 0V11M13.2 10.5V7a1.3 1.3 0 0 1 2.6 0v6.2c0 3-1.6 5.3-4.2 5.3-2.2 0-3.6-1.2-4.4-2.8L6 13.2a1.4 1.4 0 0 1 2.2-1.6L8 12" {...S} />,
  imagePlus: (
    <>
      <rect x="3.5" y="5" width="17" height="14" rx="2" {...S} />
      <path d="M3.5 15.5 8 11l3 3 2.2-2.2L20.5 16" {...S} />
      <path d="M16 8.5v3M14.5 10h3" {...S} />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8" {...S} />
      <path d="M12 11v5" {...S} />
      <rect x="11.2" y="7.2" width="1.6" height="1.6" rx="0.2" fill="currentColor" stroke="none" />
    </>
  ),
  list: (
    <>
      <path d="M9 7h10M9 12h10M9 17h10" {...S} />
      <rect x="4" y="6" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="4" y="11" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="4" y="16" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  lightbulb: (
    <>
      <path d="M9 18h6M10 21h4" {...S} />
      <path d="M8 14.5a5.5 5.5 0 1 1 8 0c-.7.8-1.2 1.6-1.2 2.5H9.2c0-.9-.5-1.7-1.2-2.5z" {...S} />
    </>
  ),
  link: (
    <>
      <path d="M10 13.5a4 4 0 0 0 5.7.4l2-2a4 4 0 0 0-5.6-5.7l-1.1 1.1" {...S} />
      <path d="M14 10.5a4 4 0 0 0-5.7-.4l-2 2a4 4 0 0 0 5.6 5.7l1.1-1.1" {...S} />
    </>
  ),
  loader: <path d="M12 4a8 8 0 1 1-6.2 3" {...S} />,
  maximize: <path d="M9 5H5v4M15 5h4v4M19 15v4h-4M5 15v4h4" {...S} />,
  megaphone: (
    <>
      <path d="M5 10v4l11 3.5V6.5L5 10z" {...S} />
      <path d="M8 14.2V17a2 2 0 0 0 2 2h.5" {...S} />
    </>
  ),
  message: (
    <>
      <path d="M5 6.5h14v9H8l-3 2.5v-11.5z" {...S} />
      <rect x="8" y="10" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  minimize: <path d="M9 5v4H5M15 5v4h4M19 15h-4v4M5 15h4v4" {...S} />,
  minus: (
    <>
      <circle cx="12" cy="12" r="8" {...S} />
      <path d="M8 12h8" {...S} />
    </>
  ),
  more: (
    <>
      <rect x="4" y="11" width="2.2" height="2.2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="10.9" y="11" width="2.2" height="2.2" rx="0.3" fill="currentColor" stroke="none" />
      <rect x="17.8" y="11" width="2.2" height="2.2" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  package: (
    <>
      <path d="M4 8.5 12 5l8 3.5V18l-8 3.5L4 18V8.5z" {...S} />
      <path d="M12 8.5V21.5M4 8.5l8 3.5 8-3.5" {...S} />
    </>
  ),
  pause: (
    <>
      <rect x="7" y="5" width="3.2" height="14" rx="0.8" {...S} />
      <rect x="13.8" y="5" width="3.2" height="14" rx="0.8" fill="currentColor" stroke="none" />
    </>
  ),
  play: (
    <>
      <rect x="3.5" y="4" width="17" height="16" rx="2" {...S} />
      <path d="M10 8.2 16.4 12 10 15.8V8.2z" fill="currentColor" stroke="none" />
    </>
  ),
  plug: (
    <>
      <path d="M8 4v5M16 4v5" {...S} />
      <path d="M6 9h12v3a6 6 0 0 1-12 0V9z" {...S} />
      <path d="M12 18v2.5" {...S} />
    </>
  ),
  printer: (
    <>
      <path d="M7 9V4.5h10V9" {...S} />
      <rect x="5" y="9" width="14" height="7" rx="1.5" {...S} />
      <path d="M7 14h10v5.5H7V14z" {...S} />
    </>
  ),
  qr: (
    <>
      <rect x="4" y="4" width="6" height="6" rx="1" {...S} />
      <rect x="14" y="4" width="6" height="6" rx="1" {...S} />
      <rect x="4" y="14" width="6" height="6" rx="1" {...S} />
      <rect x="14" y="14" width="2.2" height="2.2" fill="currentColor" stroke="none" />
      <rect x="17.8" y="17.8" width="2.2" height="2.2" fill="currentColor" stroke="none" />
    </>
  ),
  receipt: (
    <>
      <path d="M7 4.5h10v15l-2-1.2-2 1.2-1.5-1.2L10 19.5l-1.5-1.2L7 19.5v-15z" {...S} />
      <path d="M9.5 9h5M9.5 12.5h5" {...S} />
    </>
  ),
  repeat: <path d="M17 7H8.5A3.5 3.5 0 0 0 5 10.5V12M7 17h8.5A3.5 3.5 0 0 0 19 13.5V12M14.5 4.5 17 7l-2.5 2.5M9.5 19.5 7 17l2.5-2.5" {...S} />,
  rotate: <path d="M4.5 12a7.5 7.5 0 1 0 2.2-5.3M4.5 5v4.5H9" {...S} />,
  save: (
    <>
      <path d="M5 5.5h11l3 3V19a1.5 1.5 0 0 1-1.5 1.5h-12.5A1.5 1.5 0 0 1 3.5 19V7A1.5 1.5 0 0 1 5 5.5z" {...S} />
      <path d="M8 5.5V10h7V5.5M8 20v-5h8v5" {...S} />
    </>
  ),
  send: (
    <>
      <path d="M4.5 12 19 5.5 14 19l-2.2-5.2L4.5 12z" {...S} />
      <path d="M11.8 13.8 19 5.5" {...S} />
    </>
  ),
  share: (
    <>
      <rect x="14.4" y="3" width="5.4" height="5.4" rx="1" {...S} />
      <rect x="3.2" y="9.3" width="5.4" height="5.4" rx="1" fill="currentColor" stroke="none" />
      <rect x="14.4" y="15.6" width="5.4" height="5.4" rx="1" {...S} />
      <path d="M8.6 11.2 14.4 6.4M8.6 12.8 14.4 17.6" {...S} />
    </>
  ),
  shield: (
    <>
      <path d="M12 3.5 19 6.2v5.6c0 4-2.8 6.8-7 8.2-4.2-1.4-7-4.2-7-8.2V6.2L12 3.5z" {...S} />
      <rect x="10.8" y="9.2" width="2.4" height="2.4" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  shirt: (
    <>
      <path d="M8 5.5 4.5 8.5 7 11l1.2-1.5V19h7.6v-9.5L17 11l2.5-2.5L16 5.5c-1 .8-2.4 1.3-4 1.3s-3-.5-4-1.3z" {...S} />
    </>
  ),
  shuffle: <path d="M4 8h3.2l8.6 8H20M16.5 5.5 20 8l-3.5 2.5M4 16h3.2L10 13.2M16.5 18.5 20 16l-3.5-2.5" {...S} />,
  spark: (
    <>
      <path d="M12 3.6 13.4 9.2 19 10.6 13.4 12 12 17.6 10.6 12 5 10.6 10.6 9.2 12 3.6z" {...S} />
      <rect x="10.9" y="9.5" width="2.2" height="2.2" rx="0.25" fill="currentColor" stroke="none" />
    </>
  ),
  assist: (
    <>
      <path d="M5 16.2c3.2-7 7.4-7.4 10.6-2.2" {...S} />
      <path d="M13.2 9.2 17.2 12.4 13.2 12.6" {...S} />
      <rect x="3.6" y="14.2" width="3.4" height="3.4" rx="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  phone: (
    <>
      <rect x="7" y="3.2" width="10" height="17.6" rx="2" {...S} />
      <path d="M10.5 17.6h3" {...S} />
      <rect x="10.6" y="5.4" width="2.8" height="2.8" rx="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  instagram: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="4" {...S} />
      <rect x="9" y="9" width="6" height="6" rx="1.2" {...S} />
      <rect x="16.2" y="6.4" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  listVideo: (
    <>
      <rect x="3.5" y="4.5" width="10" height="7" rx="1.2" {...S} />
      <path d="M7.2 6.6 10.2 8 7.2 9.4V6.6z" fill="currentColor" stroke="none" />
      <path d="M15.5 6.5h5M15.5 10h5M3.5 16h16M3.5 19.5h10" {...S} />
    </>
  ),
  skip: (
    <>
      <path d="M5 7.2 13 12 5 16.8V7.2z" fill="currentColor" stroke="none" />
      <rect x="15.2" y="7" width="3.2" height="10" rx="0.5" fill="currentColor" stroke="none" />
    </>
  ),
  stop: (
    <rect x="6" y="6" width="12" height="12" rx="1.5" fill="currentColor" stroke="none" />
  ),
  scissors: (
    <>
      <circle cx="7" cy="7" r="2.4" {...S} />
      <circle cx="7" cy="17" r="2.4" {...S} />
      <path d="M9 8.4 19 17M9 15.6 19 7" {...S} />
      <rect x="16.6" y="10.8" width="2.6" height="2.6" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  table: (
    <>
      <rect x="3.5" y="4.5" width="17" height="15" rx="1.6" {...S} />
      <path d="M3.5 9.2h17M3.5 13.8h17M9.2 4.5v15" {...S} />
      <rect x="4.7" y="5.7" width="3" height="2.2" rx="0.25" fill="currentColor" stroke="none" />
    </>
  ),
  record: (
    <circle cx="12" cy="12" r="5.5" fill="currentColor" stroke="none" />
  ),
  star: <path d="M12 4.2 14.2 9l5.3.6-4 3.6 1.1 5.2L12 16l-4.6 2.4 1.1-5.2-4-3.6L9.8 9 12 4.2z" {...S} />,
  swords: (
    <>
      <path d="M7.2 16.8 17.6 6.4" {...S} />
      <path d="M16.8 16.8 6.4 6.4" {...S} />
      <path d="M5.1 14.2 8.4 17.5" {...S} />
      <path d="M18.9 14.2 15.6 17.5" {...S} />
      <path d="M6.4 18.2 4.6 20" {...S} />
      <path d="M17.6 18.2 19.4 20" {...S} />
      <rect x="10.85" y="10.85" width="2.3" height="2.3" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  trash: (
    <>
      <path d="M5 7.5h14" {...S} />
      <path d="M9 7.5V5.5h6v2" {...S} />
      <path d="M7 7.5 8 19h8l1-11.5" {...S} />
    </>
  ),
  undo: <path d="M8 8H5.5A6.5 6.5 0 1 1 8 17" {...S} />,
  unlink: (
    <>
      <path d="M10 13.5a4 4 0 0 0 4 .6M14 10.5a4 4 0 0 0-4-.6" {...S} />
      <path d="M8 8 6.2 6.2M16 16l1.8 1.8" {...S} />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8.5" r="3" {...S} />
      <path d="M6 18.5c.8-2.6 2.8-4 6-4s5.2 1.4 6 4" {...S} />
    </>
  ),
  userCheck: (
    <>
      <circle cx="10" cy="8.5" r="2.8" {...S} />
      <path d="M4.8 18c.7-2.4 2.4-3.6 5.2-3.6 1.2 0 2.2.2 3 .7" {...S} />
      <path d="M14.5 13.5 16.2 15.2 19.5 12" {...S} />
    </>
  ),
  userMinus: (
    <>
      <circle cx="10" cy="8.5" r="2.8" {...S} />
      <path d="M4.8 18c.7-2.4 2.4-3.6 5.2-3.6 1.4 0 2.6.3 3.5.9" {...S} />
      <path d="M15 13.5h5" {...S} />
    </>
  ),
  userPlus: (
    <>
      <circle cx="10" cy="8.5" r="2.8" {...S} />
      <path d="M4.8 18c.7-2.4 2.4-3.6 5.2-3.6 1.4 0 2.6.3 3.5.9" {...S} />
      <path d="M17.5 11v5M15 13.5h5" {...S} />
    </>
  ),
  userX: (
    <>
      <circle cx="10" cy="8.5" r="2.8" {...S} />
      <path d="M4.8 18c.7-2.4 2.4-3.6 5.2-3.6 1.2 0 2.2.2 3 .7" {...S} />
      <path d="M15.5 12.5 19 16M19 12.5l-3.5 3.5" {...S} />
    </>
  ),
  volume: (
    <>
      <path d="M5 10h3l4-3v10l-4-3H5v-4z" {...S} />
      <path d="M16 9.5a4 4 0 0 1 0 5" {...S} />
    </>
  ),
  closeCircle: (
    <>
      <circle cx="12" cy="12" r="8" {...S} />
      <path d="M9 9l6 6M15 9l-6 6" {...S} />
    </>
  ),
  zap: <path d="M13 3.5 6 13h5l-1 7.5L18 10h-5l0-6.5z" {...S} />,
  zoomIn: (
    <>
      <circle cx="11" cy="11" r="6" {...S} />
      <path d="M15.5 15.5 20 20M11 8.5v5M8.5 11h5" {...S} />
    </>
  ),
  zoomOut: (
    <>
      <circle cx="11" cy="11" r="6" {...S} />
      <path d="M15.5 15.5 20 20M8.5 11h5" {...S} />
    </>
  ),
  medal: (
    <>
      <circle cx="12" cy="14" r="5" {...S} />
      <path d="M9 5.5h6l-1.2 5.2M9 5.5 10.2 10.7" {...S} />
      <rect x="10.8" y="12.2" width="2.4" height="2.4" rx="0.3" fill="currentColor" stroke="none" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="8" {...S} />
      <path d="M4 12h16M12 4c2.2 2.4 3.2 5 3.2 8s-1 5.6-3.2 8c-2.2-2.4-3.2-5-3.2-8s1-5.6 3.2-8z" {...S} />
    </>
  ),
  statGoal: (
    <>
      <path d="M5 17.5V8.5h14v9" {...S} />
      <path d="M5 12.2h14M8.5 8.5v3.7M15.5 8.5v3.7" {...S} />
      <circle cx="12" cy="15.2" r="1.7" fill="currentColor" stroke="none" />
    </>
  ),
  statDribble: (
    <>
      <path d="M4 16.5c2.2-3.2 3.2.6 5.2-2.2 2-2.8 2.6.4 4.6-2.2 1.6-2 2.4-.2 4.2-2.2" {...S} />
      <circle cx="17.2" cy="7.2" r="2.1" {...S} />
      <path d="M16.2 6.4c.6.5 1.5.6 2.1 0" {...S} />
    </>
  ),
  statSave: (
    <>
      <path d="M8 11.5V8.2M12 10.5V6.5M16 11.5V8.2" {...S} />
      <path d="M6.5 12.5c0 3.2 2.2 5.5 5.5 5.5s5.5-2.3 5.5-5.5v-1.2H6.5v1.2z" {...S} />
    </>
  ),
  statTackle: (
    <>
      <path d="M8 5.5v5.2L4.8 18M12 5.5v4.6l5.2 7.9" {...S} />
      <circle cx="16.5" cy="8" r="1.8" {...S} />
    </>
  ),
  statChance: (
    <>
      <path d="M4.5 15.5c3.2-6.2 7-6.6 10.2-2" {...S} />
      <path d="M12.6 9.2 16.8 12.2 12.8 12.6" {...S} />
      <rect x="16.2" y="4.8" width="3.4" height="5.2" rx="0.4" {...S} />
    </>
  ),
  statShot: (
    <>
      <circle cx="7" cy="13" r="2.3" {...S} />
      <path d="M10.2 11.2 17.5 6.2" {...S} />
      <path d="M14.6 5.4 17.8 6 16.6 9" {...S} />
    </>
  ),
  statRebound: (
    <>
      <path d="M5 6.5h14v4.5H5z" {...S} />
      <path d="M8 11v3.2M16 11v3.2" {...S} />
      <circle cx="12" cy="17.2" r="2" {...S} />
    </>
  ),
  statBlock: (
    <>
      <path d="M8 15.5V9.2c0-1.2.8-2 2-2h1" {...S} />
      <path d="M11 7.2V5.5M14 7.8V5.8M17 9.2V7.2" {...S} />
      <path d="M7.5 15.5h10.5c.8 0 1.5.6 1.5 1.4v1.2H7.5v-2.6z" {...S} />
      <circle cx="6.2" cy="10" r="1.6" {...S} />
    </>
  ),
  statThree: (
    <>
      <circle cx="7.2" cy="12" r="2.4" {...S} />
      <path d="M13 8.2c2.4.6 3.2 2 1.6 3.2 2 .6 2.2 2.4-.2 3.6" {...S} />
    </>
  ),
  statFreeThrow: (
    <>
      <path d="M4 17.5h16" {...S} />
      <path d="M8 17.5c0-3.2 1.8-5.2 4-5.2s4 2 4 5.2" {...S} />
      <circle cx="12" cy="7.2" r="2" {...S} />
    </>
  ),
  statWinner: (
    <>
      <path d="M4 16.5h16" {...S} />
      <circle cx="15.5" cy="10" r="2.2" {...S} />
      <path d="M6 14.5 12.2 10.2" {...S} />
    </>
  ),
  statAce: (
    <>
      <path d="M5 16.5 16.5 6.5" {...S} />
      <circle cx="17.2" cy="6.2" r="2" fill="currentColor" stroke="none" />
      <path d="M6.5 8.5h3M7.2 11.5h2.2" {...S} />
    </>
  ),
  statSmash: (
    <>
      <path d="M6 7.5c2.4 1.2 4 3.4 4.4 6.2" {...S} />
      <path d="M8.2 6.2 11.5 8.8 8.8 10" {...S} />
      <circle cx="15.5" cy="16" r="2.1" {...S} />
    </>
  ),
  statServe: (
    <>
      <path d="M9 18.5v-6" {...S} />
      <path d="M9 12.5c2.4-1 4.2-3 4.8-5.5" {...S} />
      <circle cx="15.2" cy="6.2" r="2" {...S} />
    </>
  ),
  statLob: (
    <>
      <path d="M4.5 16.5c3.2-8 8-8.4 12.2-1.2" {...S} />
      <circle cx="17.4" cy="14.2" r="1.8" {...S} />
    </>
  ),
  statDrop: (
    <>
      <path d="M7 6.5c2.8 2 4.2 4.6 4.2 8" {...S} />
      <circle cx="11.2" cy="16.6" r="2" {...S} />
      <path d="M15.5 8.5v7" {...S} />
    </>
  ),
  history: (
    <>
      <path d="M5.5 12a6.5 6.5 0 1 0 1.7-4.4" {...S} />
      <path d="M5.2 4.6v3.6h3.6" {...S} />
      <path d="M12 8.8V12l2.3 1.5" {...S} />
    </>
  ),
  key: (
    <>
      <circle cx="8" cy="12" r="3.1" {...S} />
      <path d="M11 12h8.5M16.2 12v2.3M19 12v1.8" {...S} />
    </>
  ),
  gift: (
    <>
      <rect x="4" y="10" width="16" height="9" rx="1.5" {...S} />
      <path d="M4 10h16M12 10v9M4 13.5h16" {...S} />
      <path d="M12 10c-1.2-2.4-3.6-3.2-4.6-2.1S7.6 10 12 10c4.4 0 5.4-1.1 4.6-2.1S13.2 7.6 12 10z" {...S} />
    </>
  ),
};

export function SbIcon({ name, size = 18, className = '', title, style }) {
  const body = ICONS[name];
  if (!body) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      style={style}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title}
    >
      {body}
    </svg>
  );
}

/** Lucide-shaped wrappers so page content can use the in-house set without a rewrite of every call site. */
function glyph(name) {
  function Icon({ className = '', size, color, title, 'aria-label': ariaLabel }) {
    return (
      <SbIcon
        name={name}
        size={size}
        className={className}
        title={title || ariaLabel}
        style={color ? { color } : undefined}
      />
    );
  }
  Icon.displayName = name;
  return Icon;
}

export const Assist = glyph('assist');
export const Activity = glyph('activity');
export const AlertCircle = glyph('alert');
export const AlertTriangle = glyph('alert');
export const ArrowDownRight = glyph('arrowDownRight');
export const ArrowLeft = glyph('arrowLeft');
export const ArrowLeftRight = glyph('swap');
export const ArrowRight = glyph('arrowRight');
export const ArrowRightLeft = glyph('swap');
export const ArrowUpDown = glyph('sort');
export const ArrowUpRight = glyph('arrowUpRight');
export const Award = glyph('medal');
export const BarChart2 = glyph('analytics');
export const BarChart3 = glyph('analytics');
export const Bell = glyph('bell');
export const BookOpen = glyph('book');
export const Bookmark = glyph('bookmark');
export const Calendar = glyph('calendar');
export const CalendarDays = glyph('calendar');
export const Camera = glyph('camera');
export const Check = glyph('check');
export const CheckCircle = glyph('checkCircle');
export const CheckCircle2 = glyph('checkCircle');
export const ChevronDown = glyph('chevronDown');
export const ChevronLeft = glyph('chevronLeft');
export const ChevronRight = glyph('chevronRight');
export const CircleHelp = glyph('help');
export const Circle = glyph('record');
export const Clapperboard = glyph('video');
export const ClipboardCheck = glyph('roster');
export const Clock = glyph('clock');
export const Clock3 = glyph('clock');
export const CircleDollarSign = glyph('coins');
export const DollarSign = glyph('coins');
export const Coins = glyph('coins');
export const Compass = glyph('discovery');
export const Copy = glyph('copy');
export const CreditCard = glyph('card');
export const Crosshair = glyph('target');
export const Crown = glyph('crown');
export const Download = glyph('download');
export const Dumbbell = glyph('drills');
export const Edit = glyph('edit');
export const ExternalLink = glyph('external');
export const Eye = glyph('eye');
export const FileDown = glyph('download');
export const FileText = glyph('file');
export const Film = glyph('library');
export const Filter = glyph('filter');
export const FolderPlus = glyph('folderPlus');
export const Footprints = glyph('footprints');
export const StatGoal = glyph('statGoal');
export const StatDribble = glyph('statDribble');
export const StatSave = glyph('statSave');
export const StatTackle = glyph('statTackle');
export const StatChance = glyph('statChance');
export const StatShot = glyph('statShot');
export const StatRebound = glyph('statRebound');
export const StatBlock = glyph('statBlock');
export const StatThree = glyph('statThree');
export const StatFreeThrow = glyph('statFreeThrow');
export const StatWinner = glyph('statWinner');
export const StatAce = glyph('statAce');
export const StatSmash = glyph('statSmash');
export const StatServe = glyph('statServe');
export const StatLob = glyph('statLob');
export const StatDrop = glyph('statDrop');
export const Gamepad2 = glyph('matches');
export const Gift = glyph('gift');
export const GitBranch = glyph('branch');
export const Globe = glyph('globe');
export const GraduationCap = glyph('school');
export const History = glyph('history');
export const Grid3X3 = glyph('grid');
export const GripVertical = glyph('grip');
export const Hand = glyph('hand');
export const Image = glyph('imagePlus');
export const ImagePlus = glyph('imagePlus');
export const Info = glyph('info');
export const Instagram = glyph('instagram');
export const KeyRound = glyph('key');
export const Layers = glyph('management');
export const LayoutGrid = glyph('grid');
export const LayoutList = glyph('list');
export const Lightbulb = glyph('lightbulb');
export const Link2 = glyph('link');
export const List = glyph('list');
export const ListVideo = glyph('listVideo');
export const ListChecks = glyph('drills');
export const Loader2 = glyph('loader');
export const Lock = glyph('lock');
export const LogOut = glyph('logout');
export const Mail = glyph('mail');
export const MapPin = glyph('pin');
export const Maximize = glyph('maximize');
export const Maximize2 = glyph('maximize');
export const Megaphone = glyph('megaphone');
export const Navigation = glyph('discovery');
export const MessageCircle = glyph('message');
export const MessageSquare = glyph('message');
export const Minimize2 = glyph('minimize');
export const Minus = glyph('minus');
export const MinusCircle = glyph('minus');
export const MoreHorizontal = glyph('more');
export const Package = glyph('package');
export const Pause = glyph('pause');
export const Pencil = glyph('edit');
export const PieChart = glyph('analytics');
export const Play = glyph('play');
export const Plug = glyph('plug');
export const Plus = glyph('plus');
export const PlusCircle = glyph('create');
export const Printer = glyph('printer');
export const QrCode = glyph('qr');
export const Receipt = glyph('receipt');
export const Repeat = glyph('repeat');
export const RotateCcw = glyph('rotate');
export const Save = glyph('save');
export const School = glyph('school');
export const Scissors = glyph('scissors');
export const Search = glyph('search');
export const SearchX = glyph('search');
export const Send = glyph('send');
export const Settings = glyph('settings');
export const Share2 = glyph('share');
export const Shield = glyph('shield');
export const ShieldAlert = glyph('shield');
export const ShieldCheck = glyph('shield');
export const Shirt = glyph('shirt');
export const Shuffle = glyph('shuffle');
export const SkipForward = glyph('skip');
export const SlidersHorizontal = glyph('sliders');
export const Smartphone = glyph('phone');
export const Sparkles = glyph('spark');
export const Square = glyph('stop');
export const Star = glyph('star');
export const Swords = glyph('swords');
export const Table2 = glyph('table');
export const Tag = glyph('tag');
export const Target = glyph('target');
export const Trash2 = glyph('trash');
export const TrendingUp = glyph('analytics');
export const Trophy = glyph('competitions');
export const Undo2 = glyph('undo');
export const Unlink = glyph('unlink');
export const Upload = glyph('upload');
export const User = glyph('user');
export const UserCheck = glyph('userCheck');
export const UserCircle = glyph('user');
export const UserMinus = glyph('userMinus');
export const UserPlus = glyph('userPlus');
export const UserRound = glyph('user');
export const UserX = glyph('userX');
export const Users = glyph('users');
export const UsersRound = glyph('teams');
export const Video = glyph('video');
export const Wallet = glyph('coins');
export const Volume2 = glyph('volume');
export const X = glyph('close');
export const XCircle = glyph('closeCircle');
export const Zap = glyph('zap');
export const ZoomIn = glyph('zoomIn');
export const ZoomOut = glyph('zoomOut');

export default SbIcon;
